export const AreaOptions = [
  { value: 'comercial', text: 'Comercial' },
  { value: 'sac', text: 'SAC' },
  { value: 'financeiro', text: 'Financeiro' },
  { value: 'juridico', text: 'Jurídico' },
  { value: 'ti', text: 'TI' },
];

export default AreaOptions;
